
import { useCallback, useEffect, useState } from "react"
import { Form } from "antd"
import { useReceivedPaymentDetailServices } from "@pages/collectionAdministration/pages/ReceivedPaymentDetail/hooks/useReceivedPaymentDetailServices"
import useCurrentLocation from "@thooks/useCurrentLocation"
import { useReceivedPaymentDetailContext } from "@pages/collectionAdministration/pages/ReceivedPaymentDetail/context/ReceivedPaymentDetailContext"

export const useExtraordinaryPaymentModal = ({ handleOpenCloseModal, record }) => {
    //Usar un contexto tanto para traer los datos del cargo si existen como para guardarlos
    const { getInitialData } = useReceivedPaymentDetailContext()
    const [loadingExtraordinaryPaymentModal, setLoadingExtraordinaryPaymentModal] = useState(false)
    const { param } = useCurrentLocation()
    const [fileList, setFileList] = useState([])
    const [paymentTypes, setPaymentTypes] = useState([])

    const { getChargeInstanceDebtorPaymentTypesService, createAdminPaymentChargeService } = useReceivedPaymentDetailServices()
    const [form] = Form.useForm()

    const getInitialModalData = useCallback(async () => {
        const res = await getChargeInstanceDebtorPaymentTypesService()
        setPaymentTypes(res.data?.map(({ charge_instance_debtor_payment_type_id, name }) => ({ id: charge_instance_debtor_payment_type_id, name })))
    }, [getChargeInstanceDebtorPaymentTypesService])

    const handleSaveExtraordinaryPayment = useCallback(async ({ values }) => {
        const formData = new FormData()
        formData.append('charge_instance_id', param.chargeInstanceId)
        formData.append('place_id', record?.place_id)
        formData.append('charge_instance_debtor_payment_type_id', values.charge_instance_debtor_payment_type_id)
        formData.append('file', fileList[0].originFileObj)

        const res = await createAdminPaymentChargeService({ formData, setLoading: setLoadingExtraordinaryPaymentModal })
        console.log(res)
        setLoadingExtraordinaryPaymentModal(false)
        //Obtener de nuevo los datos del cobro
        await getInitialData({ charge_instance_id: param.chargeInstanceId })
        handleOpenCloseModal({ isOpenModal: false, name: 'extraordinary_payment' })

    }, [handleOpenCloseModal, record, param, createAdminPaymentChargeService, getInitialData, fileList])

    useEffect(() => {
        getInitialModalData()
    }, [getInitialModalData])

    return {
        loadingExtraordinaryPaymentModal,
        form,
        fileList,
        paymentTypes,
        handleSaveExtraordinaryPayment,
        setFileList,
    }
}